import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';

import { agenticAiChatAtom } from '../store/index.js';

const useAgenticChat = () => {
  const [chatSessionId, setChatSessionId] = useAtom(agenticAiChatAtom);
  const resetChat = useResetAtom(agenticAiChatAtom);

  return {
    chatSessionId,
    setChatSessionId,
    resetChat,
  };
};

export default useAgenticChat;
